import React, { useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"

import { ASC, EDIT } from "const"
import { MtProjectGroup } from "server/models"
import { deepCopy, hasAccess } from "client/utils"
import {
    PRM_ACCOUNT_SETTINGS,
    StoreType,
    ProjectGroupList,

    LoadProjectGroups,
    SortProjectGroups,
    DeleteProjectGroup,
    DragnDropProjectGroup,

    setProjectGroupList,
    setProjectGroupIds,
    addModal,
} from "client/store"
import {
    Table,
    DeleteRow,
    DragnDrop,
    Button,
} from "client/components"

import Columns from "./columns"
import EditDefaultGroup from "./edit"

const DefaultGroups = () => {
    const groupList = useSelector((state: StoreType) => state.projectGroup.groupList)
    const groupIds = useSelector((state: StoreType) => state.projectGroup.groupIds)
    const reloadList = useSelector((state: StoreType) => state.projectGroup.reloadList)

    const defaultGroupsAssigned = useSelector((state: StoreType) => state.system.accountSettings.project.defaultGroupsAssigned)
    const userData = useSelector((state: StoreType) => state.system.userData)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const LoadData = () => {
        LoadProjectGroups(userData.accountId, null, defaultGroupsAssigned)
        .then((res) => {
            dispatch(setProjectGroupList(res))
        })
    }

    useEffect(() => {
        if (!reloadList) return
        LoadData()
    }, [reloadList, defaultGroupsAssigned])

    useEffect(() => {
        const sortedIds = SortProjectGroups(Object.values(groupList), "order", ASC, {})
        dispatch(setProjectGroupIds(sortedIds))
    }, [groupList])

    const onDelete: DeleteRow = (group: MtProjectGroup, callback) => {
        DeleteProjectGroup(group.groupId, userData.accountId, null).then((removedRows) => {
            const success = removedRows === 1
            callback(success, () => {
                const groupListCopy: ProjectGroupList = groupList ? deepCopy(groupList) : {}
                delete groupListCopy[group.groupId]
                dispatch(setProjectGroupList(groupListCopy))
                dispatch(setProjectGroupIds(groupIds.filter((id) => id !== group.groupId)))
            })
        })
    }

    const onDragnDrop: DragnDrop = (dataIds, callback) => {
        dispatch(setProjectGroupIds(dataIds))
        DragnDropProjectGroup(dataIds, userData.accountId, null).then((success) => {
            LoadData()
            callback(success)
        })
    }

    const columns = Columns()
    const editAccess = hasAccess(PRM_ACCOUNT_SETTINGS, EDIT)

    return (
        <Table
            title={lang.defaultGroups}
            columns={columns}
            dataList={groupList}
            dataIds={groupIds}
            rowSize="sm"
            onDelete={onDelete}
            onDragnDrop={onDragnDrop}
            bottomContent={editAccess && (
                <Button
                    variant="success"
                    onClick={() => dispatch(addModal({
                        key: "addProjectGroup",
                        content: <EditDefaultGroup groupData={null} />,
                    }))}
                >
                    {lang.add}
                </Button>
            )}
        />
    )
}
export default DefaultGroups
